$(document).ready(function () {
  var sliders = [
    {
        selector: '.recommendations .carousel-recommendations .pdp-vertival-tiles-container',
        initialize: initializeVerticalSlickSlider,
    },
    {
        selector: '.product-recomm-clp .product-recom-slider .product-recom-slider-recomm',
        initialize: initializeHorizontalSlickSliderProduct,
    },
    {
        selector: '.cart-recommendations .recommendations .carousel-recommendations .pdp-tiles-container',
        initialize: initializeHorizontalSlickSliderCart,
    },
    {
        selector: '.product-recom-slider .custom-carousel .home-asset-product-recomm',
        initialize: initializeHorizontalSlickSliderHome,
    },
    {
        selector: '.product-recom-slider .tiles-container',
        initialize: initializeNoSearchResultSlickSlider,
    },
    {
        selector: '#cart-modal .product-recom-slider .tiles-container',
        initialize: initializeAddToCartModalSlickSlider,
    },
    {
        selector: '#cart-modal .add-to-cart-modal-recommendations .pdp-tiles-container',
        initialize: initializeAddToCartModalNostoSlickSlider,
    },
    {
        selector: '.recommendations .carousel-recommendations .pdp-tiles-container',
        initialize: initializeHorizontalSlickSlider,
    }
  ];

  const initializeSlider = function (slider) {
      $(slider.selector).not('.slick-initialized, .pdp-nosto-static-recommendations').each(function () {
          slider.initialize($(this));
      });
  };

  var checkSelectors = function () {

    sliders.forEach((slider) => {
        initializeSlider(slider);
    });

    // Continue checking for selectors after a short delay
    setTimeout(checkSelectors, 1000);
};

  // Initial check when the document is ready
  checkSelectors();
});

function initializeVerticalSlickSlider($selector) {
  initializeSlickSlider($selector, 2, $(window).width() > 768);
}

function initializeHorizontalSlickSlider($selector) {
  initializeSlickSlider($selector, 4);
}

function initializeHorizontalSlickSliderProduct($selector) {
  initializeSlickSlider($selector, 4);
}

function initializeHorizontalSlickSliderCart($selector) {
    initializeSlickSlider($selector, 3);
}

function initializeHorizontalSlickSliderHome($selector) {
  initializeSlickSlider($selector, 4);
}

function initializeNoSearchResultSlickSlider($selector) {
    initializeSlickSlider($selector, 3);
}

function initializeAddToCartModalSlickSlider($selector) {
    initializeSlickSlider($selector, 3);
}

function initializeAddToCartModalNostoSlickSlider($selector) {
    initializeSlickSlider($selector, 3);
}

function refreshVerticalSliderAfterImageLoad($selector) {
    const $firstProductImage = $selector
        .find('.slick-slide')
        .not('.slick-cloned')
        .first()
        .find('img')
        .first();
    const refreshSliderPosition = function () {
        if ($selector.hasClass('slick-initialized')) {
            $selector.slick('setPosition');
        }
    };

    if (!$firstProductImage.length || $firstProductImage[0].complete) {
        refreshSliderPosition();
    } else {
        $firstProductImage.one('load error', refreshSliderPosition);
    }
}

function shouldUseStaticPdpNostoLayout($selector, slidesToShow, vertical) {
    const slideCount = $selector.children('.recommendation-item').length;

    return !vertical
        && $selector.closest('.pdp-nosto-recommendations').length
        && slideCount > 0
        && slideCount < slidesToShow;
}

function initializeStaticPdpNostoLayout($selector) {
    $selector
        .addClass('pdp-nosto-left-align pdp-nosto-static-recommendations')
        .attr('role', 'region')
        .attr('aria-label', 'Product')
        .attr('aria-atomic', 'true');

    $selector.find('.image-container').addClass("pl-2 pr-2");
}

function initializeSlickSlider($selector, slidesToShow, vertical = false) {
    const util = __webpack_require__(/*! ./util */ "./janieandjack-sfra/cartridges/app_janieandjack_storefront/cartridge/client/default/js/util.js");

  // Define the number of slides for different viewports
    const responsiveSettings = [
      {
          breakpoint: 992,  // Breakpoint for tablets
          settings: {
              slidesToShow: 3,
          },
      },
      {
          breakpoint: 576,  // Breakpoint for mobile devices
          settings: {
              slidesToShow: 2,
          },
      },
    ];

    if (!($selector.hasClass('slick-initialized'))) {
        if (shouldUseStaticPdpNostoLayout($selector, slidesToShow, vertical)) {
            initializeStaticPdpNostoLayout($selector);
            return;
        }

        // ARIA attributes for carousel container
        $selector
            .attr('role', 'region')
            .attr('aria-label', 'Product')
            .attr('aria-roledescription', 'carousel')
            .attr('aria-atomic', 'true');

        $selector.slick({
            arrows: true,
            dots: false,
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            vertical: vertical,
            verticalSwiping: vertical,
            prevArrow: '<a class="slider-prev">' + util.svg('Arrow_small', 'left-arrow') + '</a>',
            nextArrow: '<a class="slider-next">' + util.svg('Arrow_small', 'right-arrow') + '</a>',
            responsive: (vertical) ? {} : responsiveSettings
        });

        if (vertical) {
            refreshVerticalSliderAfterImageLoad($selector);
        }

        // Add ARIA attributes to each slide
        $selector.find('.slick-slide').each(function (index) {
            $(this)
                .attr('role', 'group')
                .attr('aria-roledescription', 'slide')
                .attr('aria-label', `Slide ${index + 1}`)
                .attr('aria-hidden', !$(this).hasClass('slick-active'));
        });
        $selector.find('.slider-prev').attr('role', 'button');
        $selector.find('.slider-prev').attr('tabindex', '0');
        $selector.find('.slider-prev').attr('aria-label', 'Previous slide');
        $selector.find('.slider-next').attr('role', 'button');
        $selector.find('.slider-next').attr('tabindex', '0');
        $selector.find('.slider-next').attr('aria-label', 'Next slide');
        $selector.find('.slick-track').attr('aria-live', 'polite');

       const containerClasses = [
          '.image-container',
          '.image-container',
          '.image-container',
          '.image-container',
          '.image-container',
      ];
        containerClasses.forEach((containerClass) => {
            $selector.find(containerClass).addClass("pl-2 pr-2");
        });

    }
    const cartRecommendations = $(".cart-recommendations.large-up");
    const isSlickInitialized = cartRecommendations.find('.slick-initialized').length > 0;
    const isWindowWidthLessThan767 = $(window).width() < 767;

    if (isSlickInitialized && isWindowWidthLessThan767) {
        $(".promoandrecomm").append(cartRecommendations);
    }
}
